import type { RoutesData } from '@/router/routerInitPlugin'
import OgImg from '@/assets/og_image.jpg?url'
import { buildLangRoute } from '@/router/langRouteBuilder'
import { routesTranslations } from '@/router/routesTranslations'

const isProd = import.meta.env?.VITE_PROD === 'on'

export default (): RoutesData[] => {
  return [
    ...(!isProd
      ? [{
          path: '/admin/add-game',
          name: 'admin-add-game',
          component: () => import('@/pages/admin/AddGamePage.vue'),
          meta: { pageData: { title: 'GOAT Admin — Game Settings', description: '', bodyClass: 'bg-[#0a1a1f]' } }
        }]
      : []),
    ...buildLangRoute({
      path: `${routesTranslations['how-to-delete-my-data-page']?.en?.slug}`,
      name: 'how-to-delete-my-data-page',
      component: () => import('@/pages/info/HowToDeleteMyData.vue'),
      meta: {
        pageData: {
          image: OgImg,
          bodyClass: 'bg-gs-body-bg'
        }
      }
    }),
    ...buildLangRoute({
      path: `/${routesTranslations['home-page']?.en?.slug}`,
      name: 'home-page',
      component: () => import('@/pages/index/IndexPage.vue'),
      meta: {
        pageData: {
          image: OgImg,
          bodyClass: 'bg-gs-body-bg'
        }
      }
    })
  ]
}
